export default __webpack_public_path__ + "static/media/sbj-computerscience.d3dad3f9.svg";